import { PaymentType } from 'src/types/dto';
import { useCheckoutFormValuesStore } from '../stores';
import { useGetCheckoutRoutesVerification } from './useGetCheckoutRoutesVerification';

const useNextLabelButton = () => {
  const { isConfirmCardRoute, isAddCardRoute, isPaymentRoute } =
    useGetCheckoutRoutesVerification();

  const { formValues } = useCheckoutFormValuesStore();

  const paymentLabel =
    formValues.selectedPaymentType === PaymentType.Gratuito
      ? 'Concluir'
      : 'Pagar';

  if (isAddCardRoute) return 'Adicionar cartão';
  if (isConfirmCardRoute) return 'Confirmar Valor';
  if (isPaymentRoute) {
    return !formValues.selectedPaymentType
      ? 'Forma de pagamento'
      : `${paymentLabel}`;
  }
  return 'Avançar';
};

export default useNextLabelButton;
